import { useGtm } from '@gtm-support/vue-gtm'
export const useGTagManager = () => {
  const gtm = useGtm()
  return {
    gtm,
  }
}
